<button
  type="button"
  [ngClass]="cardClass()"
  class="p-3 text-left w-full"
  (click)="emitClick($event)"
  (keydown)="$event.key === 'Enter' && emitKeyEnter($event)"
  [disabled]="disabled()"
>
  <div class="flex flex-col w-full">
    <ng-content></ng-content>
  </div>
</button>
